import { render, staticRenderFns } from "./RequestAccommodationVisit.vue?vue&type=template&id=65355ffa&scoped=true"
import script from "./RequestAccommodationVisit.vue?vue&type=script&lang=js"
export * from "./RequestAccommodationVisit.vue?vue&type=script&lang=js"
import style0 from "./RequestAccommodationVisit.vue?vue&type=style&index=0&id=65355ffa&prod&lang=scss&scoped=true"
import style1 from "./fichaVisita.css?vue&type=style&index=1&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65355ffa",
  null
  
)

export default component.exports